// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__rPupY","upload":"Small_upload__jwIZF","imageWrap":"Small_imageWrap__1DdE9","removeBtn":"Small_removeBtn___49sI"};